module.exports = __webpack_public_path__ + "img/scale-grouping.c4111081.png";